import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './plansetup.module.scss';
import { ExpandMore } from '@mui/icons-material';
import { Button, Chip } from '@mui/material';
import FilterData from './FilterData';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { format } from 'date-fns';

interface PlanProps {
  handleClick: () => void;
}

const PlanSetup: React.FC<PlanProps> = ({ handleClick }) => {
  const { params } = useSelector((state: RootState) => state.ExMenuRequisitionParams);
  const [value, setValue] = useState(0);
  const [expanded, setExpanded] = useState<boolean>(true);

  // Destructure dynamic fields from params
  const {
    requesttype = '',
    cafenames = [],
    sitename,
  } = params ?? {};
  const deliveryDate = params?.deliverydate ? format(new Date(params.deliverydate), 'dd MMM yyyy') : 'No Date';

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleToggleChange = () => {
    setExpanded(!expanded);
  };

  return (
    <div className='white-box mb-12'>
      <div
        className={`flex justify-content-between align-items-center ${expanded ? styles.tabbingDataWrap : styles.tabbingDataWrapMinimize
          }`}
      >
        {expanded ? (
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='Tabs'
            className={!expanded ? 'tabs-wrapper colapsed' : 'tabs-wrapper'}
          >
            <Tab label="Filter" id={`simple-tabpanel-${0}`} aria-labelledby={`simple-tab-${0}`} disableRipple />
          </Tabs>
        ) : (
          <div className='flex align-items-center'>
            {/* Dynamic Delivery Date */}
            <div className={styles.dateRange}>
              <span className={styles.dateLabel}>Delivery Date:</span>
              <span className={styles.date}>{deliveryDate}</span>
            </div>
            {/* Dynamic Site */}
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Site:</span>
              <span className={styles.chipData}>{sitename}</span>
            </div>

            {/* Dynamic Cafe Names */}
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Cafe:</span>
              <span className={styles.chipData}>
                {cafenames.map((cafe: string, index: number) => (
                  <Chip key={index} label={cafe} className={styles.chip} />
                ))}
              </span>
            </div>

            {/* Dynamic Requested Type */}
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Requested Type:</span>
              <span className={styles.chipData}>{requesttype}</span>
            </div>
          </div>
        )}
        <Button
          onClick={handleToggleChange}
          className={`expend-btn ${expanded && 'active'}`}
          disableRipple
        >
          {expanded ? 'Minimize Section' : 'Expand'}
          <span>
            <ExpandMore />
          </span>
        </Button>
      </div>
      <div className={`inner-contant ${!expanded && 'd-none'}`}>
        <CustomTabPanel value={value} index={0}>
          <FilterData handleClick={handleClick} handleMenuChange={handleToggleChange} />
        </CustomTabPanel>
      </div>
    </div>
  );
};

export default PlanSetup;
